"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgAddPolygon(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M18 0a2 2 0 011.001 3.732v8.536a2 2 0 11-2.733 2.733H7.732a2 2 0 11-1.245-2.941l9.573-9.573A2 2 0 0118 0zm-1 4.375L8.375 13h7.893a2.01 2.01 0 01.732-.732zM8 0v2h2v2H8v2H6V3.999L4 4V2l2-.001V0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('AddPolygon')(SvgAddPolygon);
//# sourceMappingURL=AddPolygon.js.map